import { FC } from 'react';

import { Path, Svg, type SvgProps } from './svg';

export const Tag: FC<SvgProps> = (props) => (
	<Svg width={24} height={24} viewBox="0 0 24 24" {...props}>
		<Path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.5002 2.58579C11.8753 2.21071 12.384 2 12.9144 2H20.0002C21.1048 2 22.0002 2.89543 22.0002 4V11.0858C22.0002 11.6162 21.7895 12.1249 21.4144 12.5L13.1215 20.7929C11.9499 21.9645 10.0504 21.9645 8.87887 20.7929L3.20729 15.1213C2.03572 13.9497 2.03572 12.0503 3.20729 10.8787L11.5002 2.58579ZM20.0002 4H12.9144L4.62151 12.2929C4.23098 12.6834 4.23098 13.3166 4.62151 13.7071L10.2931 19.3787C10.6836 19.7692 11.3168 19.7692 11.7073 19.3787L20.0002 11.0858V4ZM14.0002 8.00003C14.0002 6.89546 14.8956 6.00003 16.0002 6.00003C17.1048 6.00003 18.0002 6.89546 18.0002 8.00003C18.0002 9.1046 17.1048 10 16.0002 10C14.8956 10 14.0002 9.1046 14.0002 8.00003Z"
			fill="currentColor"
		/>
	</Svg>
);
